// extracted by mini-css-extract-plugin
export var copyableField = "_qd-4";
export var customerBadge = "_qd-0";
export var customerInfoTitle = "_qd-2";
export var details = "_qd-1";
export var dropdownContainer = "_qd-5";
export var dropdownImage = "_qd-6";
export var editAssigneeForm = "_qd-a";
export var editButton = "_qd-3";
export var email = "_qd-7";
export var hidden = "_qd-d";
export var input = "_qd-8";
export var saveButton = "_qd-b";
export var shopifyIcon = "_qd-c";
export var suggestionBadge = "_qd-e";
export var suggestionText = "_qd-f";
export var username = "_qd-9";